import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { useParams, useLocation } from 'react-router-dom'
import Spinner from 'shared-module/components/Spinner'
import useCamera from 'camera-module/camera/core/useCamera'
import { PhotosProvider } from 'photo-module/photos/ui/photos-gallery/PhotoContext'
import TopBar from 'photos-module/photos/ui/photos-gallery/PhotoGalleryTopBar'
import FiltersBar from 'photos-module/filters/ui/SpypointFiltersBar'
import PhotoContainer from 'photos-module/photos/ui/photo-viewer-preview/SpypointPhotoPreviewContainer'
import PhotoPreview from 'photo-module/photo/ui/photo-viewer/PhotoPreview'
import PhotoViewer from 'photo-module/photo/ui/photo-viewer/PhotoViewer'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '150px',
    [theme.breakpoints.only('sm')]: {
      marginTop: '140px',
    },
    [theme.breakpoints.only('xs')]: {
      marginTop: '115px',
    },
  },
  paperContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '1.25rem',
    padding: '1.25rem',
    [theme.breakpoints.down('xs')]: {
      margin: '1rem 0',
      padding: '1rem 0.5rem 1rem 1rem',
    },
  },
}))

const Dashboard = ({ isNewUi = false }) => {
  const classes = useStyles()
  const { id: cameraId, cameraId: cameraIdFromPhoto, photoId } = useParams()
  const location = useLocation()

  const activeCameraId = cameraId || cameraIdFromPhoto
  const selectedCamera = useCamera(activeCameraId)
  const shared = JSON.parse(localStorage.getItem('isShared'))

  // Determine which component to render based on route
  const isPhotoPreview = location.pathname.includes('/preview')
  const isPhotoViewer = photoId && !isPhotoPreview
  const isGalleryView = !photoId

  const renderFilterBar = () => {
    const isNoCellularCamera = !selectedCamera?.isCellular
    if (isNoCellularCamera && !shared) {
      return null
    }

    return <FiltersBar />
  }

  const renderPhotoContainer = () => (
    <Paper elevation={1} className={classes.paperContainer}>
      <PhotoContainer cameraId={activeCameraId} />
    </Paper>
  )

  const renderGalleryView = () => (
    <div className={classes.root}>
      <TopBar />
      { renderFilterBar() }
      { renderPhotoContainer() }
    </div>
  )

  const renderContent = () => {
    if (isPhotoPreview) {
      return <PhotoPreview />
    }

    if (isPhotoViewer) {
      return <PhotoViewer />
    }

    return renderGalleryView()
  }

  if (!selectedCamera) {
    return <Spinner />
  }

  return (
    <PhotosProvider>
      { renderContent() }
    </PhotosProvider>
  )
}

export default Dashboard
